import { gql } from "@apollo/client";

export const GET_EVALUACIONES_RI_EV = gql`
query getEvaluacionesRIEV($filter: ConsultaRIEVFilterInput!){
    evaluacionesRIEV (filter: $filter) {    
        success,
        error,
        valorEsperado {
            idProfesional,
            profesional,
            idPaciente,
            paciente,
            contrato,
            formulario,
            digitalizado,
            idEvaluacion,
            idEvolucionRIMedico
        }
    }
  }
`;